export enum ClearanceStatus {
    Cleared = 1,
    OnHold = 2,
    InProgress = 3,
}

export enum ClearanceTypes {
    SFD = 'SFD',
    SAD = 'SAD',
    FULL_IMPORT_ENTRY = 'Full import entry',
    DOM_PROC = 'Dom.proc',
}

export const clearanceStatusOptions = [
    { value: '', optionText: 'Select value...' },
    { value: ClearanceStatus.Cleared, optionText: 'Cleared' },
    { value: ClearanceStatus.OnHold, optionText: 'On hold' },
    { value: ClearanceStatus.InProgress, optionText: 'In progress' },
];

export const clearanceTypesOptionsFirst = [
    { value: '', optionText: 'Select value...' },
    { value: ClearanceTypes.SFD, optionText: ClearanceTypes.SFD },
    { value: ClearanceTypes.DOM_PROC, optionText: ClearanceTypes.DOM_PROC },
];

export const clearanceTypesOptionsSecond = [
    { value: '', optionText: 'Select value...' },
    { value: ClearanceTypes.SFD, optionText: ClearanceTypes.SFD },
    { value: ClearanceTypes.SAD, optionText: ClearanceTypes.SAD },
    { value: ClearanceTypes.FULL_IMPORT_ENTRY, optionText: ClearanceTypes.FULL_IMPORT_ENTRY },
    { value: ClearanceTypes.DOM_PROC, optionText: ClearanceTypes.DOM_PROC },
];

export enum HoldTypesEmum {
    XRAY = 1,
    PHYSICAL_INSPECTION = 2,
    DOCUMENT_INSPECTION = 3,
}

export const HoldTypes = {
    [HoldTypesEmum.XRAY]: 'X-Ray',
    [HoldTypesEmum.PHYSICAL_INSPECTION]: 'Physical Inspection',
    [HoldTypesEmum.DOCUMENT_INSPECTION]: 'Document Inspection',
}

export const holdTypesOptions = [
    { value: '', optionText: 'Select value...' },
    { value: HoldTypesEmum.XRAY, optionText: 'X-Ray' },
    { value: HoldTypesEmum.PHYSICAL_INSPECTION, optionText: 'Physical Inspection' },
    { value: HoldTypesEmum.DOCUMENT_INSPECTION, optionText: 'Document Inspection' },
];

export const originDestDropdown = [
    { optionText: 'CY/CY', label: 'CY/CY', value: 'CY/CY' },
    { optionText: 'CFS/CY', label: 'CFS/CY', value: 'CFS/CY' },
    { optionText: 'CY/CFS', label: 'CY/CFS', value: 'CY/CFS' },
    { optionText: 'CFS/CFS', label: 'CFS/CFS', value: 'CFS/CFS' },
    { optionText: 'CY/-', label: 'CY/-', value: 'CY/-' },
    { optionText: 'CFS/-', label: 'CFS/-', value: 'CFS/-' }
];

export const originDestDropdownNew = [
    { optionText: 'CY', label: 'CY', value: 'CY' },
    { optionText: 'CFS', label: 'CFS', value: 'CFS' },
];

export const searchProductTypes = [
    { optionText: 'NETWORK', value: 'NETWORK' },
    { optionText: 'BKS', value: 'BKS' },
];

export const searchProductTypesExtra = [
    { optionText: 'NETWORK', value: 0 },
    { optionText: 'BKS', value: 1 },
];

export const transportationDropdown = [
    { optionText: 'AIR', value: 'AIR' },
    { optionText: 'RAIL', value: 'RAIL' },
    { optionText: 'OCEAN', value: 'OCEAN' },
    { optionText: 'SEA', value: 'SEA' },
    { optionText: 'TRUCK', value: 'TRUCK' },
]

export const messageDropdown = [
    { optionText: 'With Error', label: 'With Error', value: 'true' },
    { optionText: 'Without Error', label: 'Without Error', value: 'false' },
];  

export enum currentPageMode {
    edit = 'edit',
    add = 'add',
}

export enum localCurrency {
    totalLocalCurrency = 'totalLocalCurrency'
}
export enum pageName {
    EXPORT_JOB = 'EXPORTJOB'
}

export enum timeDelay {
    costRevenue = 50
}

export enum fcrType {
    RECEIVING = 'RFREV',
}

export const RECEIVING_SALES_ORDER_TAB_TITLE = 'Order Management';

export enum uamType {
    JOBCOSTING = 'FinOps (Payables, Logs)',
    ADMIN = 'FinOps (Administration)',
}

export enum jobClose {
    REOPEN = 'This Job is expected to be closed during weekend after 3 days from the Job Reopened Date. Ensure any corrections needed from FinOps are carried out within 3 days',
    CLOSE = 'This Sales order cannot be modified or invoiced from FinOps. Job needs to be reopened from SAP and status here should be changed to Open before doing any changes or invoicing from FinOps'
}

export const pricingSourceOptions = [
    { optionText: 'Athena', value: 'ATHENA' },
    { optionText: 'SAP', value: 'SAP' },
];